export const BGGREY = "grey";
export const BGWHITE = "white";
export const BGBLUE = "blue";
export const BGRED = "red";
export const ALIGNCENTER = "center";
export const ALIGNLEFT = "left";
export const ALIGNRIGHT = "right";